interface GuestSubscribeModalProps {
  calendarName: string;
  calColor: string;
  isPending: boolean;
  onSubscribe: () => void;
  onDismiss: () => void;
}

export default function GuestSubscribeModal({
  calendarName,
  calColor,
  isPending,
  onSubscribe,
  onDismiss,
}: GuestSubscribeModalProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4 bg-ink-900/40"
      onClick={e => {
        if (e.target === e.currentTarget) onDismiss();
      }}
    >
      <div className="paper-card w-full max-w-sm overflow-hidden">
        {/* Accent strip */}
        <div
          className="h-1.5 w-full"
          style={{ backgroundColor: calColor }}
        />

        {/* Body */}
        <div className="p-6 space-y-4">
          <div className="flex items-start gap-3">
            <span
              className="w-4 h-4 rounded-sm shrink-0 mt-0.5"
              style={{ backgroundColor: calColor }}
            />
            <div>
              <h2 className="font-serif text-xl font-bold text-ink-900 leading-tight">
                {calendarName}
              </h2>
              <p className="font-mono text-xs text-ink-400 mt-0.5">
                You're viewing as a guest
              </p>
            </div>
            <button
              onClick={onDismiss}
              className="ml-auto text-ink-300 hover:text-ink-600 transition-colors shrink-0"
              aria-label="Dismiss"
            >
              <svg
                viewBox="0 0 16 16"
                fill="currentColor"
                className="w-4 h-4"
              >
                <path d="M3.72 3.72a.75.75 0 0 1 1.06 0L8 6.94l3.22-3.22a.75.75 0 1 1 1.06 1.06L9.06 8l3.22 3.22a.75.75 0 1 1-1.06 1.06L8 9.06l-3.22 3.22a.75.75 0 0 1-1.06-1.06L6.94 8 3.72 4.78a.75.75 0 0 1 0-1.06Z" />
              </svg>
            </button>
          </div>

          <p className="text-sm text-ink-600 leading-relaxed">
            Subscribe to add this calendar to your sidebar and
            see its events in your personal view.
          </p>

          <div className="flex gap-3 justify-end pt-1">
            <button
              onClick={onDismiss}
              className="btn-ghost"
            >
              Not now
            </button>
            <button
              onClick={onSubscribe}
              disabled={isPending}
              className="px-4 py-2 text-sm font-mono text-white rounded-sm hover:opacity-90 transition-opacity disabled:opacity-50"
              style={{ backgroundColor: calColor }}
            >
              {isPending ? 'Subscribing…' : 'Subscribe'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
